import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../../../environments/environment';
import { BodyListResponse } from '../../../../core/models/general/body-list-response';
import { UploadUploadNotificacionesDTO } from '../../../../core/models/upload/uploadUploadNotificaciones-DTO';
import { BodyResponse } from '../../../../core/models/general/body-response';

const API_URL = environment.apiUrlUpload;

@Injectable()
export class UploadUploadNotificacionesService {
    header = new Headers({ 'Content-Type': 'application/json' });

    constructor(private http: HttpClient) { }

    getUploadUploadNotificacionesService() {
        return this.http.get<BodyListResponse<UploadUploadNotificacionesDTO>>(
            API_URL + '/api/v1/uploadNotificaciones/todos'
        );
    }
    uploadUploadNotificacionesActivosService() {
        return this.http.get<BodyListResponse<UploadUploadNotificacionesDTO>>(
            API_URL + '/api/v1/uploadNotificaciones'
        );
    }

    uploadUploadNotificacionesUsuarioActivo(usuario: string) {
        return this.http.get<BodyListResponse<UploadUploadNotificacionesDTO>>(
            API_URL + '/api/v1/uploadNotificaciones/usuario/'+usuario
        );
    }

    guardarUploadUploadNotificacionesService(uploadUploadNotificacionesDTO: UploadUploadNotificacionesDTO) {
        return this.http.post(API_URL + '/api/v1/uploadNotificaciones', uploadUploadNotificacionesDTO);
    }

    getUploadUploadNotificacionesPorCodigoNotificacionService(codigoNotificacion: string) {
        return this.http.get<BodyResponse<UploadUploadNotificacionesDTO>>(
            API_URL + '/api/v1/uploadNotificaciones/' + codigoNotificacion
        );
    }
}
